import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SwitchPageService, PageName } from './switch-page.service';
import { tap, takeUntil } from 'rxjs';
import { log } from '@root/util/logger';
import { Subject } from 'rxjs';
import { MultiHouseCalendarService } from '../calendar/multi-house-calendar/multi-house-calendar.service';

/** @TODO @FIXME 该组件最好和关联组件封装到component里 */

@Component({
  selector: 'host-order-detail-sidebar',
  templateUrl: './order-detail-sidebar.component.html',
  styleUrls: ['./order-detail-sidebar.component.scss'],
})
export class OrderDetailSidebarComponent implements OnInit, OnDestroy {
  readonly PageName: typeof PageName = PageName;
  selectedReservation = null;
  /** @deprecated */
  orderPageInfo = null;

  pageName: PageName;
  pagePayload;
  private selectedReservation$ = this.houseCalendarService.selectReservationRaw$.pipe(
    tap((value) => {
      this.selectedReservation = value;
      // this.switchPageService.destroyCurrentLianBiao();

      if (value) {
        this.houseCalendarService.cancelSelect();
        this.houseCalendarService.cancelSelectTask();
        // this.selectedReservation = value;

        this.switchPageService.navigate(PageName.OrderDetail, { code: value, pageType: 'sidebar' });
      } else {
        this.switchPageService.go(0);
      }
    })
  );

  private currentOrderPageRaw$ = this.switchPageService.currentNodeRaw$.pipe(
    tap((value) => {
      this.orderPageInfo = value;
    })
  );

  private switchPage$ = this.switchPageService.switchPageRaw$.pipe(
    tap((value) => {
      // console.log('switch page: ', value);

      if (!value) {
        this.pageName = null;
        this.pagePayload = null;
        return;
      }

      const { name, payload } = value;
      this.pageName = name;
      this.pagePayload = payload;
    })
  );

  private destroy$ = new Subject();
  constructor(private houseCalendarService: MultiHouseCalendarService, private switchPageService: SwitchPageService) {}

  ngOnInit() {
    this.selectedReservation$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();
    this.switchPage$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
